import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { SoundFamiliar } from './components/SoundFamiliar';
import { CoreInsight } from './components/CoreInsight';
import { ProductReveal } from './components/ProductReveal';
import { WhatYouGet } from './components/WhatYouGet';
import { MasterGuide } from './components/MasterGuide';
import { Bonuses } from './components/Bonuses';
import { Benefits } from './components/Benefits';
import { HowItWorks } from './components/HowItWorks';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { PurchaseNotifications } from './components/PurchaseNotifications';
type AppProps = {
  showPurchaseNotifications?: boolean;
};
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full overflow-x-hidden bg-ivory font-sans text-navy" data-id="element-0" data-mp="3ijpbavgxap74">
      <Hero data-id="element-1" data-mp="3mkhofzsx1e8o" />
      <main data-id="element-2" data-mp="3mjzuj9tq7c3x">
        <SoundFamiliar data-id="element-3" data-mp="3mjpyp5m02aqb" />
        <CoreInsight data-id="element-4" data-mp="3rc9dg5wfbbwp" />
        <ProductReveal data-id="element-5" data-mp="3rbrcwx2qabiz" />
        <WhatYouGet data-id="element-6" data-mp="3rdkg22e4udm8" />
        <MasterGuide data-id="element-7" data-mp="3rd189ei755lx" />
        <Bonuses data-id="element-8" data-mp="5yjetptzbev" />
        <Benefits data-id="element-9" data-mp="6hrlipoilfp" />
        <HowItWorks data-id="element-10" data-mp="4wupmfw6qeo" />
        <Offer data-id="element-11" data-mp="5ghbgghm2z1" />
        <Guarantee data-id="element-12" data-mp="82k72sfnuax" />
        <Testimonials data-id="element-13" data-mp="2zl3c5m4yv85u" />
        <Faq data-id="element-14" data-mp="2zlv66six0xu0" />
        <FinalCta data-id="element-15" data-mp="2zm4xqkjlzd1t" />
      </main>
      {showPurchaseNotifications ? <PurchaseNotifications data-id="element-16" data-mp="33moqzd129wio" /> : null}
    </div>;
}